import styled from "@emotion/styled"

export const LabelVariantsWrapper = styled.div<{
	status: "green" | "yellow" | "blue" | "purple" | "orange"
}>`
	height: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	> div {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 6px;
		border-radius: 50px;
		padding: 8px 12px;
		height: 25px;
		background-color: ${(props) =>
			props.status === "blue"
				? "#F5F9FE"
				: props.status === "purple"
					? "#EEEBFF"
					: props.status === "green"
						? "#F3FBF4"
						: props.status === "yellow"
							? "#FFFCF4"
							: props.status === "orange"
								? "#FFF4E6"
								: ""};
		span {
			&.badg {
				width: 10px;
				height: 10px;
				border-radius: 50px;
				background-color: ${(props) =>
					props.status === "blue"
						? "#3087E9"
						: props.status === "purple"
							? "#5B3FFF"
							: props.status === "green"
								? "#16AE26"
								: props.status === "yellow"
									? "#FDBF21"
									: props.status === "orange"
										? "#FF8C00"
										: ""};
			}
			&.label {
				color: ${(props) =>
					props.status === "blue"
						? "#3087E9"
						: props.status === "purple"
							? "#5B3FFF"
							: props.status === "green"
								? "#16AE26"
								: props.status === "yellow"
									? "#FDBF21"
									: props.status === "orange"
										? "#FF8C00"
										: ""};
			}
		}
	}
`
